import { NotificationService } from './notification.service';

export const notificationService = new NotificationService();
